var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 31,
    viewBox: "0 0 39 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1 0H3.9C1.755 0 0.0195 1.74375 0.0195 3.875L0 27.125C0 29.2563 1.755 31 3.9 31H35.1C37.245 31 39 29.2563 39 27.125V3.875C39 1.74375 37.245 0 35.1 0ZM35.1 27.125H3.9V7.75L19.5 17.4375L35.1 7.75V27.125ZM19.5 13.5625L3.9 3.875H35.1L19.5 13.5625Z",
    fill: "#ED553B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon2);
export default __webpack_public_path__ + "static/media/quoteIcon2.1bc34389b9f06eaa0d143a07179cdbfe.svg";
export { ForwardRef as ReactComponent };